import { Head } from '@inertiajs/react';
import type { LandingsWire } from '@/types';
import { WireBus } from './components/wire-bus';

// `app/(public)/26-co/wire/page.tsx`.
export default function Wire({ title, description }: LandingsWire) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <main className="relative min-h-dvh w-full overflow-hidden bg-background text-foreground md:h-dvh">
        <WireBus />
      </main>
    </>
  );
}
